import { useQuery } from '@tanstack/react-query'
import * as turf from '@turf/turf'
import type { BBox, Feature, Polygon } from 'geojson'
import { useMemo } from 'react'
import getSoils from '../../services/ruutsApi/getSoils'
import { queryKeys } from './queryKeys'

export const useSoilsIntersections = (
  farmId: string | undefined,
  perimeter: Feature<Polygon> | undefined,
) => {
  // Soils only matter inside the farm, so the perimeter's bounding box is the request window.
  const bbox = useMemo(() => (perimeter ? turf.bbox(perimeter) : undefined), [perimeter])

  return useQuery({
    queryKey: queryKeys.soils(farmId, bbox?.join(',')),
    queryFn: ({ signal }) =>
      getSoils({ geoJSON: turf.bboxPolygon(bbox as BBox) as Feature<Polygon>, signal }),
    enabled: !!farmId && !!bbox,
  })
}
